import "./search.scss";
import { useEffect, useState } from "react";
import { BsArrowLeftCircle } from "react-icons/bs";
import sendRequest2 from "hooks/useAxios2";
import { NavLink } from "react-router-dom";
import { useDetectClickOutside } from "react-detect-click-outside";
export default function Search() {
  const clearSearchValue = () => {
    setsSearchValue("");
  };
  const ref = useDetectClickOutside({ onTriggered: clearSearchValue });

  const [searchValue, setsSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState("");

  useEffect(() => {
    if (searchValue !== "") {
      sendRequest2("search_keyword", { keyword: searchValue }).then(
        ({ data }) => {
          setSearchResult(data.data);
        }
      );
    } else {
      setSearchResult([]);
    }
  }, [searchValue]);

  return (
    <div className="search-container mx-auto">
      <div
        className="position-relative search-input "
        style={{ width: "100%" }}
        ref={ref}
      >
        <input
          type="text"
          style={{ height: 46, borderRadius: 10 }}
          className="form-control bg-light  border ps-5"
          placeholder="جستجو"
          value={searchValue}
          onChange={(e) => {
            setsSearchValue(e.target.value);
          }}
        />
        <i
          className="fa-solid fa-magnifying-glass position-absolute"
          style={{ right: 10, top: 16 }}
        />
      </div>
      {searchResult.length != 0 && (
        <div className="search-result-container">
          <SearchResultItemContainer
            title={"محصولات"}
            type="products"
            searchResult={searchResult}
          />
          <SearchResultItemContainer
            title={"برند ها"}
            type="brand"
            searchResult={searchResult}
          />
          <SearchResultItemContainer
            title={"برچسب ها"}
            type="hashtags"
            searchResult={searchResult}
          />
          <SearchResultItemContainer
            title={"مطالب"}
            type="posts"
            searchResult={searchResult}
          />
        </div>
      )}
    </div>
  );
}
function SearchResultItemContainer({ title, searchResult, type }) {
  const showResultBaseOnType = () => {
    let temp;
    switch (type) {
      case "brand":
        temp = searchResult.brand?.map((value) => (
          <>
            <NavLink
              to={`/specific-products/keyword=تمام کالا ها با برند ${value.name}&tags=&brands=${value.id}&priceform=0&priceto=100&rankform=0&rankto=5&color=&sorttype=_____&`}
              style={{ textDecoration: "none" }}
            >
              <div className="value-container">
                <div className="title">
                  مشاهده همه کالا های برند
                  <span className="value"> {value.name} </span>
                </div>
              </div>
            </NavLink>
          </>
        ));
        return temp.length !== 0 ? temp : <small>نتیجه ای یافت نشد!</small>;

      case "hashtags":
        temp = searchResult.hashtags?.map((value) => (
          <>
            <NavLink
              to={`/specific-products/keyword=تمام کالا ها با برچسب ${value.txt}&tags=${value.id}&brands=&priceform=0&priceto=100&rankform=0&rankto=5&color=&sorttype=_____&`}
              style={{ textDecoration: "none" }}
            >
              <div className="value-container">
                <div className="title">
                  مشاهده تمام کالاها با برچسب
                  <span className="value"> {value.txt} </span>
                </div>
              </div>
            </NavLink>
            <NavLink
              to={`specific-articles/keyword=تمام مطالب با برچسب ${value.txt}&tags=${value.id}&datefrom=&dateto=&`}
              style={{ textDecoration: "none" }}
            >
              <div className="value-container">
                <div className="title">
                  مشاهده تمام مطالب با برچسب
                  <span className="value"> {value.txt} </span>
                </div>
              </div>
            </NavLink>
          </>
        ));
        return temp.length !== 0 ? temp : <small>نتیجه ای یافت نشد!</small>;

      case "posts":
        temp = searchResult.posts?.map((value) => (
          <NavLink
            to={`/article/${value.id}`}
            style={{ textDecoration: "none" }}
          >
            <div className="value-container">
              <div className="title">
                مطالعه مطلب
                <span className="value"> {value.title} </span>
              </div>
            </div>
          </NavLink>
        ));
        return temp.length !== 0 ? temp : <small>نتیجه ای یافت نشد!</small>;

      case "products":
        temp = searchResult.products?.map((value) => (
          <NavLink
            to={`/product/${value.id}`}
            style={{ textDecoration: "none" }}
          >
            <div className="value-container">
              <div className="title">
                مشاهده محصول
                <span className="value"> {value.title} </span>
              </div>
            </div>
          </NavLink>
        ));
        return temp.length !== 0 ? temp : <small>نتیجه ای یافت نشد!</small>;

      default:
        break;
    }
  };
  return (
    <>
      <div>
        <div className="search-result-item-container">
          <div className="header ">
            <div className="title-section" style={{ paddingRight: "3px" }}>
              {title}
            </div>
            {/* <div className="left-arrow">
              <BsArrowLeftCircle></BsArrowLeftCircle>
            </div> */}
          </div>

          <span className="search-value">{showResultBaseOnType()}</span>
        </div>
      </div>
    </>
  );
}
